import { successType } from "redux-api-status";
import initialState from "./initialState";
import * as types from "../actions/actionTypes";
import {
  WEBSOCKET_CONNECTED,
  WEBSOCKET_DISCONNECTED,
  WEBSOCKET_ERROR,
} from "../actions/internalUsersActions";
export default function internalUsersReducer(
  state = initialState.internalUsers,
  action
) {
  switch (action.type) {
    case successType(types.LOAD_INTERNALUSER):
      return {
        ...state,
        LoggedInUser: action.payload.data,
      };
    case WEBSOCKET_CONNECTED:
      return { ...state, WebSocket: "Connected" };
    case WEBSOCKET_DISCONNECTED:
      return { ...state, WebSocket: "Disconnected" };
    case WEBSOCKET_ERROR:
      return { ...state, WebSocket: "Error" };
    case successType(types.UPDATE_INTERNALUSER_AVATAR):
      return {
        ...state,
        LoggedInUser: action.payload.data,
      };
    case successType(types.LOAD_INTERNALUSERS):
      return {
        ...state,
        List: action.payload.data,
      };
    case successType(types.LOAD_LISTTYPES):
      return {
        ...state,
        ListTypes: action.payload.data,
      };
    case successType(types.LOAD_POLICYDOCUMENTS):
      return {
        ...state,
        PolicyDocuments: action.payload.data,
      };

    case successType(types.LOAD_CLIENTMARKETINGEMAILTEMPLATES):
      return {
        ...state,
        ClientMarketingEmailTemplates: action.payload.data,
      };

    case successType(types.LOAD_STATS_DAYS):
      return {
        ...state,
        StatsDays: action.payload.data,
      };
    case successType(types.LOAD_STATS_RECENTBOOKINGSTATUS):
      return {
        ...state,
        RecentBookingStatus: action.payload.data,
      };
    case successType(types.LOAD_STATS_WEEKONWEEKSTATS):
      return {
        ...state,
        WeekOnWeekStats: action.payload.data,
      };

    case successType(types.LOAD_STATS_CLIENTCONTACT):
      return {
        ...state,
        StatsClientContact: action.payload.data,
      };
    case successType(types.LOAD_STATS_CANDIDATES):
      return {
        ...state,
        StatsCandidates: action.payload.data,
      };
    case successType(types.LOAD_INTERNAL_NOTIFICATIONS):
      return {
        ...state,
        Notifications: action.payload.data,
      };
    default:
      return state;
  }
}
